export default {
    SET_EMPLEADOS: (state, payload) => {
        state.empleados = payload;
    },
    SET_EMPLEADOS_FILTROS: (state, payload) => {
        state.empleadosFiltros = payload;
    },
    SET_DEPARTMENTS: (state, payload) => {
        state.departments = payload;
    },
    SET_TOTAL_PERSONAL: (state, payload) => {
        state.totalPersonal = payload
    },
    SET_EMPLEADOS_EXPORT: (state, payload) => {
        state.empleadosExport = payload;
    },
    SET_EMPLEADOS_FILTERS_EXPORT: (state, payload) => {
        state.empleadosFiltersExport = payload;
    },
}